// Native React render of Oscar's pagination.html partial (prev / "Page X of Y"
// / next). All labels + URLs are resolved server-side (documents.shell.build_pagination)
// so fr_CA is preserved; this component only renders the resolved structure.
import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

type IPaginationData = NonNullable<
    templates.AddressListDocumentTemplate["pagination"]
>;

type IProps = Immutable<{
    data: IPaginationData;
}>;

export const Pagination = ({ data }: IProps): React.JSX.Element => (
    <nav>
        <ul className="pagination justify-content-center">
            {data.has_previous && (
                <li className="page-item">
                    <a className="page-link" href={data.previous_url}>
                        {data.previous_label}
                    </a>
                </li>
            )}
            <li className="page-item disabled">
                <span className="page-link">{data.page_label}</span>
            </li>
            {data.has_next && (
                <li className="page-item">
                    <a className="page-link" href={data.next_url}>
                        {data.next_label}
                    </a>
                </li>
            )}
        </ul>
    </nav>
);
